import React from "react";
import { Modal, ModalBody } from "@vds/modals";
import { Title } from "@vds/typography";
import { Icon } from "@vds/icons";
import { FlexColumn, FlexRow, SmallText } from "../../components/core/utility";
import { Button } from "@vds/buttons";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

const StyledModal = css`
  max-height: 99vmin;
  padding: 1rem 1rem 1rem 1rem;
  border-radius: 0.5rem;
  width: auto !important;
  @media (max-width: 767px) {
    width: auto% !important;
    height: auto;
    min-height: 14.5rem;
    padding: 1rem 1rem 1rem 1rem;
    padding-right: 2px;
  }
  .ModalDialogWrapper-sc-ov12ij-0 > span.hULveg {
    padding-right: 0px;
  }

  & footer {
    padding: 0;
  }
`;
const StyledSpan = styled.span`
  font-weight: bold;
`;
const DeleteModal = ({ isOpen, onClose, title, row, handleConfirmDelete, showCancelButton = false }) => {
  return (
    <Modal
      role="dialog"
      ariaLabel="Configure MMIDs"
      hideCloseButton={false}
      opened={isOpen}
      disableOutsideClick
      css={StyledModal}
      closeButton={
        <FlexRow justifyContent="space-between" style={{ marginLeft: "1.3rem", marginTop: "1rem" }} onClick={(event) => event.preventDefault()}>
          <Title>{title}</Title>
          <div onClick={onClose} style={{ marginRight: "1rem" }}>
            <Icon
              aria-label="close"
              alt="close-icon"
              role="img"
              name="close"
              size="medium"
              color="#000000"
              style={{ cursor: "pointer", outline: "none" }}
            />
          </div>
        </FlexRow>
      }
    >
      <ModalBody>
        {title === "Delete Vehicle" && (
          <FlexColumn justifyContent="center" style={{ height: "100%" }}>
            {row?.displayVinId ? (
              <SmallText bold>
                {row?.vehicle}-{row?.year} {row?.make} {row?.model}
              </SmallText>
            ) : (
              <SmallText bold>
                {row?.year} {row?.make} {row?.model}
              </SmallText>
            )}

            <SmallText>Are you sure you want to delete this vehicle?</SmallText>
          </FlexColumn>
        )}
        {title === "Delete Asset" && (
          <FlexColumn justifyContent="center" style={{ height: "100%" }}>
            <SmallText>Are you sure you want to delete this asset?</SmallText>
          </FlexColumn>
        )}
        {title === "Delete All" && (
          <FlexColumn justifyContent="center" style={{ height: "100%" }}>
            <SmallText>Are you sure you want to delete all items? This action cannot be undone.</SmallText>
          </FlexColumn>
        )}
        {title === "Delete Key Fob" && (
          <FlexColumn justifyContent="center" style={{ height: "100%" }}>
            <SmallText bold>{row?.subscriptionName}</SmallText>
            <SmallText>Are you sure you want to delete this key fob?</SmallText>
          </FlexColumn>
        )}
        {title === "Bulk Delete" && (
          <FlexColumn justifyContent="center" style={{ height: "100%" }}>
            <SmallText>Are you sure you want to delete the</SmallText>
            <SmallText>
              <StyledSpan>
                {Number(row?.deleteEligible || 0)} {row.AssetType}s{" "}
              </StyledSpan>
              from the <StyledSpan>{row.BundleName}</StyledSpan>?
            </SmallText>
          </FlexColumn>
        )}
        <FlexRow justifyContent="flex-end" style={{ marginTop: "20px" }}>
          {showCancelButton ? (
            <Button size="small" secondary onClick={onClose} style={{ marginRight: "10px" }}>
              Cancel
            </Button>
          ) : (
            <></>
          )}
          <Button size="small" onClick={handleConfirmDelete} style={{ marginRight: "10px" }}>
            Confirm
          </Button>
        </FlexRow>
      </ModalBody>
    </Modal>
  );
};
export default DeleteModal;
